import i18n from '@dms/i18n';
import {useCountry} from '@dms/shared';

import {Field} from './primitives/Field';

export function LastRegistrationCountrySelect() {
  const {sortedCountriesOptions} = useCountry();

  return (
    <Field
      type="choice"
      name="lastRegistrationCountry"
      label={i18n.t('entity.vehicle.labels.lastRegistrationCountry')}
      options={sortedCountriesOptions ?? []}
    />
  );
}
